import { FormattedMessage } from 'react-intl';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Link } from '@mui/material';

import { Offering } from '@arrived/models';

import { SocialSharePopper } from '../../SocialShareButtons';

interface PropertyDetailsBackButtonProps {
  offering: Offering;
  handleOnBackButtonClick: () => void;
}

export const PropertyDetailsPageHeader = ({ offering, handleOnBackButtonClick }: PropertyDetailsBackButtonProps) => {
  return (
    <Box display={{ xs: 'none', md: 'flex' }} alignItems="center" justifyContent="space-between" py={1}>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        component="button"
        variant="h6"
        onClick={handleOnBackButtonClick}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          fontSize: '1rem',
          lineHeight: '1.2rem',
          color: ({ palette }) => palette.darkened.midnight,
        }}
      >
        <ArrowBackIcon fontSize="inherit" sx={{ marginRight: '8px' }} />
        <FormattedMessage id="back-to-invest" defaultMessage="Back to all properties" />
      </Link>
      <SocialSharePopper offering={offering} />
    </Box>
  );
};
